import { getExperiment } from '@eventbrite/statsig';
import { useEffect, useState } from 'react';

type ExperimentVariant = string;

/**
 * **IMPORTANT**
 * Hook assumes the statsig SDK
 * has been initialized and returns the
 * expected variant. It is not listening
 * for the initialization to re-trigger
 * fetching an experiment.
 *
 * According to statsig docs, the `getExperiment`
 * lookup is a synchronous operation and so should
 * have little latency overhead.
 *
 * Until mounted on the client, the hook will return
 * 'loading'. Allowing server side content to
 * render appropriately until the expected variant
 * is provided.
 *
 * @param experimentName
 * @param paramName
 * @returns
 */
export const useGetStatsigExperiment = (
    experimentName: string,
    paramName: string,
    defaultValue: any,
    enabled = true,
): 'loading' | ExperimentVariant => {
    //TODO: Update shared hook to return useQuery esque object providing
    //explicit loading and data states.
    //https://eventbrite.atlassian.net/browse/EB-200465
    const [experimentVariant, setExperimentVariant] = useState('loading');

    useEffect(() => {
        if (enabled) {
            const variant = getExperiment(
                experimentName,
                paramName,
                defaultValue,
            );
            setExperimentVariant(variant);
        }
    }, [experimentName, paramName, defaultValue, enabled]);

    return experimentVariant;
};
